"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Storage = exports.PermissionRole = exports.DataOperation = void 0;
var DataOperation;
(function (DataOperation) {
    DataOperation["insert"] = "insert";
    DataOperation["update"] = "update";
    DataOperation["get"] = "get";
    DataOperation["remove"] = "remove";
    DataOperation["find"] = "find";
    DataOperation["count"] = "count";
})(DataOperation = exports.DataOperation || (exports.DataOperation = {}));
var PermissionRole;
(function (PermissionRole) {
    /**
     * Anyone (anonymous) can perform the operation
     */
    PermissionRole["anyone"] = "anyone";
    /**
     * User of user can perform the opration
     */
    PermissionRole["siteMember"] = "siteMember";
    /**
     * User of user who is the owner (producer) of the
     * data can perform the operation.
     *
     * In regular Wix Data collections, this allows
     * performing operation on an item if _owner field
     * matches the currently logged Site Member id.
     *
     * In case of DB drivers, this can match the
     * ownership that is appropriate to vertical, ex.:
     * UoU can see his purchases, or contact can see
     * his details.
     */
    PermissionRole["siteMemberAuthor"] = "siteMemberAuthor";
    /**
     * Site Admin can perform the operation.
     */
    PermissionRole["admin"] = "admin";
})(PermissionRole = exports.PermissionRole || (exports.PermissionRole = {}));
var Storage;
(function (Storage) {
    /**
     * DB driver collection
     */
    Storage["driver"] = "driver";
    /**
     * User collection
     */
    Storage["docstore"] = "docstore";
    /**
     * App builder collection
     */
    Storage["app"] = "app";
    /**
     * External db driver collection
     */
    Storage["expernal"] = "external";
})(Storage = exports.Storage || (exports.Storage = {}));
//# sourceMappingURL=schema.js.map